import { filter, find } from 'lodash';

/**
 * Test if a list of terms are included in a single string and retuns the ones that are included
 * @category Getters
 * @category String
 */
export function getTermsIncluded(value?: string | null, terms: string[] = []) {
  if (!value) return [];

  // either regexp and indexOf based on tests can bug depending on the tested term
  // so comparing words and terms by this way looks to be more reliable
  const textWords = value.split(' ');
  const filteredTerms = filter(terms, (term) =>
    find(textWords, (word) => word.toLowerCase() === term),
  );

  return filteredTerms;
}
